import { GET_LOCK_TYPES_LOADING, GET_LOCK_TYPES_SUCCESS } from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';

export const getLockTypesSuccess = payload => {
    return ({
        type: GET_LOCK_TYPES_SUCCESS,
        payload
    })
}

export const getLockTypesAsync = payload => dispatch => {
    return client.service('lock-types').find()
		.then((response) => {
            dispatch(getLockTypesSuccess(response));
            return response;
		})
        .catch((error) => {
            console.error('error', error);
        })
           
}